import script from "./AllTicketsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AllTicketsView.vue?vue&type=script&setup=true&lang=js"

import "./AllTicketsView.vue?vue&type=style&index=0&id=5e7923c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7923c0"]])

export default __exports__